import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

const Navigation = () => {

const expand = false;

  return (
    <>
        <Navbar key={expand} expand={expand} className="bg-body-tertiary mb-3">
          <Container fluid>
            <Navbar.Brand href="/" style={{display:'flex', alignItems: 'center'}}>
                <img
                src="/logo.png"
                alt="Logo"
                width="45"
                height="45"
                className="d-inline-block align-top mx-2"
                />{' '}
                TN Bill-E</Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  TN Bill-E
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link href="/">November Midterm Guide</Nav.Link>
                  <Nav.Link href="/elections/tn">County Lookup</Nav.Link>
                  <Nav.Link href="/elections/tn/august-2026">August Election Archive</Nav.Link>
                  <Nav.Link href="/bills">Bill Archive</Nav.Link>
                  <form action="https://www.paypal.com/donate" method="post" target="_top" className="my-3">
                        <input type="hidden" name="business" value="A29YD42ZQ5VLG" />
                        <input type="hidden" name="no_recurring" value="0" />
                        <input type="hidden" name="item_name" value="Support tnbills.com public election guides, bill archives, and civic explainers for Tennesseans." />
                        <input type="hidden" name="currency_code" value="USD" />
                        <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                        <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                    </form>
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
    </>
  );
}

export default Navigation;
